import { IconProps } from "@/types/common";
import React from "react";

const CommentIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M5 3.5H18C18.7956 3.5 19.5587 3.81607 20.1213 4.37868C20.6839 4.94129 21 5.70435 21 6.5V15.5C21 16.2956 20.6839 17.0587 20.1213 17.6213C19.5587 18.1839 18.7956 18.5 18 18.5H13.41L9.71 22.21C9.53 22.39 9.28 22.5 9 22.5C8.73478 22.5 8.48043 22.3946 8.29289 22.2071C8.10536 22.0196 8 21.7652 8 21.5V18.5H5C4.20435 18.5 3.44129 18.1839 2.87868 17.6213C2.31607 17.0587 2 16.2956 2 15.5V6.5C2 5.70435 2.31607 4.94129 2.87868 4.37868C3.44129 3.81607 4.20435 3.5 5 3.5ZM18 4.5H5C4.46957 4.5 3.96086 4.71071 3.58579 5.08579C3.21071 5.46086 3 5.96957 3 6.5V15.5C3 16.0304 3.21071 16.5391 3.58579 16.9142C3.96086 17.2893 4.46957 17.5 5 17.5H9V21.5L13 17.5H18C18.5304 17.5 19.0391 17.2893 19.4142 16.9142C19.7893 16.5391 20 16.0304 20 15.5V6.5C20 5.96957 19.7893 5.46086 19.4142 5.08579C19.0391 4.71071 18.5304 4.5 18 4.5Z" />
    </svg>
  );
};

export default CommentIcon;
